import { useEffect, useState } from 'react';

import { useGlobalQueries } from '@/exceed';

const useEmbedChat = ({
  chatPath,
  exceedUrl = window.location.origin,
  id,
  targetRef,
  userId,
  widgetUrl,
}) => {
  const [isLoadingWidget, setIsLoadingWidget] = useState(true);
  const currentUserId = useGlobalQueries().currentUser.data.id;
  const exceedUserId = userId ?? currentUserId;

  useEffect(() => {
    const renderElement = targetRef.current;

    if (!widgetUrl || renderElement === null) return;

    const renderEvent = new CustomEvent('tribeChat.renderInline', {
      detail: {
        exceedUri: exceedUrl,
        exceedUserId,
        iFrameId: id,
        path: chatPath,
        renderElement,
        tribeDomain: new URL(widgetUrl).origin,
      },
    });

    const onWidgetLoaded = () => {
      setIsLoadingWidget(false);
      document.dispatchEvent(renderEvent);
    };

    const { body } = document;

    const script = Object.assign(document.createElement('script'), {
      onload: onWidgetLoaded,
      src: widgetUrl,
    });

    body.appendChild(script);

    return () => body.removeChild(script);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatPath, exceedUrl, exceedUserId, id, targetRef.current, widgetUrl]);

  return { isLoadingWidget };
};

export default useEmbedChat;
